import { combineReducers, Reducer } from 'redux';
import Auth, { AuthState } from './Auth';
import Theme from './Theme';
import { AuthAction, UserAction, DocumentAction } from '../actions';
import { User, UserState } from './User';
import { Document, DocumentState } from './Document';

export interface ReduxState {
  auth: AuthState;
  theme: any;
  user: UserState;
  document: DocumentState;
}

const reducers: Reducer<ReduxState, AuthAction | UserAction | DocumentAction> = combineReducers({
  theme: Theme,
  auth: Auth,
  user: User,
  document: Document,
});

export default reducers;
